// AUTO-GENERATED — do not edit. Regenerated by: npx nx run lms-web:generate-env
/** Register callback URL at Potato: {origin}/login/callback */
export const environment = {
  production: false,
  appVersion: "1.0.0",
  /**
   * Empty = browser calls same-origin /api/... on localhost:4200;
   * dev server proxies to remote API (see dev-api-target.json + proxy.conf.mjs).
   */
  apiBaseUrl: "https://api-dev-lms.coditas.org",
  potato: {
    baseUrl: "https://potato.coditas.org",
    clientId: "9904f5b2-fac0-494b-b5bb-8af87a75742c",
    scopes: "openid profile email",
  },
};
